import { GlobalVariables } from '../pdf/GlobalVariables';
import { devError, devLog, isFirefox } from './developmentUtils';

export function clearClipboard(): Promise<void> {
    //GlobalVariables.copiedText = '';
    return navigator.clipboard.writeText('');
}

export function writeToClipboard(content: string): Promise<void> {
    return clearClipboard().then(() => {
        // Special handling for Firefox, since reading clipboard is not allowed.
        if (isFirefox()) {
            GlobalVariables.copiedText = content;
        }
        devLog(content);
        return navigator.clipboard.writeText(content);
    });
}

export async function readFromClipboard(): Promise<string> {
    // Special handling for Firefox, since reading clipboard is not allowed.
    if (isFirefox()) {
        return GlobalVariables.copiedText;
    }

    try {
        const contents = await navigator.clipboard.read();

        if (!contents?.length) {
            return '';
        }

        const content = contents[0];

        if (content.types.includes('text/plain')) {
            const blob = await content.getType('text/plain');
            return blob.text();
        }

        return '';
    } catch (error) {
        devError(error as Error);
        return '';
    }
}
